// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Barlow_52f0b0', '__Barlow_Fallback_52f0b0'","fontStyle":"normal"},"className":"__className_52f0b0","variable":"__variable_52f0b0"};